import { render, staticRenderFns } from "./MagnitoAccount.vue?vue&type=template&id=09ec0f1c&"
import script from "./MagnitoAccount.vue?vue&type=script&lang=js&"
export * from "./MagnitoAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports